import React from "react";
import { Modal, Button, Container, Row, Col } from "react-bootstrap";
import style from "./Modal.module.scss";
import { TODIS_PRIMARY_BTN, TODIS_OUTLINE_BTN } from "../Buttons";
import arrow from "../../assets/icons/arrow-white.svg";

const TODIS_MODAL = (props) => {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className={style.todisModalContainer}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {props.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Row>
                        <Col lg={12}>
                            {
                                props.iconBody &&
                                <props.iconBody style={{width: "100%", height: "170px"}} color="#3db73d"/>
                            }
                        </Col>
                        <Col lg={12} className="pt-4">
                            <h4 className="fw-bold text-center" style={{color: "#004494"}}>
                                {props.bodyText}
                            </h4>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            {/* <Modal.Footer>
                {/* <TODIS_PRIMARY_BTN onclick={props.onHide}>Dicard</TODIS_PRIMARY_BTN>
                <TODIS_OUTLINE_BTN onclick={props.onHide}>Resume</TODIS_OUTLINE_BTN> */}
                {/* <Button variant="outline-primary"  className="todis-btn" type="reset">DISCARD </Button>
                <Button variant="primary" onClick={props.onHide} className="todis-submit-btn" type="submit">RESUME <img src={arrow} width="15" className="todis-icon-btn" alt="submit" /></Button> 
            </Modal.Footer> */}
        </Modal>
    )
}

export { TODIS_MODAL };